import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const TransactionsEmptyTableFeatureIcon = ({
  width = '120',
  height = '110',
  color = '#CCC',
  className = ''
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 122 110"
      className={className}
    >
      <g clipPath="url(#clip0_3215_58553)">
        <path
          fill={color}
          d="M59.574 29.01l6.485-5.812-5.724-.18a.573.573 0 00-.59.554l-.171 5.438zM88.847 31.041l-7.258-7.069 6.9.217c.316.01.564.274.554.59l-.196 6.262z"
        ></path>
        <path
          stroke={color}
          strokeWidth="2.5"
          d="M58.482 36.952l.635-12.855a1.718 1.718 0 011.77-1.633l26.532.834c.947.03 1.691.821 1.663 1.768l-.626 21.34"
        ></path>
        <path
          fill="#fff"
          d="M83.412 46.921c.17-5.417-4.082-9.946-9.499-10.116-5.417-.17-9.946 4.083-10.116 9.5a9.778 9.778 0 00.727 4.032l18.888-3.416z"
        ></path>
        <path
          stroke={color}
          strokeWidth="1.84"
          d="M83.506 46.863c.172-5.453-4.11-10.012-9.563-10.184-5.453-.171-10.012 4.11-10.183 9.563a9.843 9.843 0 00.731 4.06"
        ></path>
        <path
          fill={color}
          d="M78.238 46.957a4.374 4.374 0 01-.314 1.515c-.193.469-.446-.056-.888.252h-.81c.294-.177.53-.428.71-.753.18-.333.284-.681.312-1.045l-3.224-.101a6.031 6.031 0 01-.36.942 3.61 3.61 0 01-.546.796c-.21.222-.457.396-.74.523a2.331 2.331 0 01-1.01.171 2.325 2.325 0 01-1.716-.803 2.725 2.725 0 01-.495-.83 2.874 2.874 0 01-.21-.959l-.839-.026.02-.61.837.027c.015-.457.113-.903.296-1.338a2.69 2.69 0 01.81-1.093l.735.862a1.97 1.97 0 00-.606.693 1.967 1.967 0 00-.245.907l3.161.1c.121-.336.25-.662.387-.98.137-.317.307-.596.51-.835.193-.248.432-.44.716-.575.284-.143.633-.208 1.048-.195a2.381 2.381 0 011.79.856c.213.244.378.529.494.855.117.325.183.67.197 1.035l.9.028-.018.61-.902-.029zm-8.302-.26c.063.416.226.756.49 1.019.254.253.584.386.99.4.22.006.408-.022.562-.085.155-.071.29-.164.403-.28.114-.123.216-.264.305-.422a11.9 11.9 0 00.246-.538l-2.996-.095zm7.331-.38a1.805 1.805 0 00-.46-1.095 1.36 1.36 0 00-1.015-.476 1.32 1.32 0 00-.6.108c-.173.08-.32.189-.443.329s-.225.302-.308.486c-.09.175-.168.359-.233.552l3.06.096z"
        ></path>
        <circle
          cx="73.834"
          cy="31.45"
          r="2.366"
          fill={color}
          transform="rotate(-88.2 73.834 31.45)"
        ></circle>
        <path
          fill={color}
          d="M27.13 34.303l4.248-7.602-5.472 1.687a.573.573 0 00-.379.716l1.603 5.199zM54.977 26.566l-9.16-4.332 6.598-2.034a.573.573 0 01.716.378l1.846 5.988z"
        ></path>
        <path
          stroke={color}
          strokeWidth="2.5"
          d="M33.035 56.072l-7.88-26.186a1.718 1.718 0 011.14-2.137l25.345-7.815a1.718 1.718 0 012.148 1.136l9.192 29.79"
        ></path>
        <path
          fill="#fff"
          d="M55.59 43.492c-1.608-5.214-7.137-8.137-12.35-6.53-5.214 1.608-8.137 7.137-6.53 12.35a9.837 9.837 0 004.006 5.34L54.1 52.266a9.864 9.864 0 001.49-8.774z"
        ></path>
        <path
          stroke={color}
          strokeWidth="1.84"
          d="M54.1 52.266a9.864 9.864 0 001.49-8.774c-1.608-5.214-7.137-8.137-12.35-6.53-5.214 1.608-8.137 7.137-6.53 12.35a9.837 9.837 0 004.006 5.34"
        ></path>
        <path
          fill={color}
          d="M50.638 45.29c.157.51.222 1.02.194 1.535-.03.505-.204.975-.522 1.41l-1.002-.621c.22-.263.363-.578.427-.943a2.606 2.606 0 00-.043-1.09l-3.083.95c.016.341.005.677-.035 1.008a3.605 3.605 0 01-.258.93 2.3 2.3 0 01-.531.736 2.332 2.332 0 01-.899.49c-.34.104-.671.136-.994.094a2.365 2.365 0 01-.89-.298 2.722 2.722 0 01-.737-.623 2.87 2.87 0 01-.51-.84l-.802.248-.18-.583.801-.247a3.722 3.722 0 01-.154-1.361c.03-.479.167-.911.412-1.296l.975.576a1.97 1.97 0 00-.349.852c-.055.31-.034.622.063.937l3.022-.932c.006-.356.022-.706.048-1.05.027-.346.097-.664.21-.956.104-.298.268-.557.492-.776.222-.228.532-.404.928-.526a2.382 2.382 0 011.971.23c.28.161.529.377.745.647.216.27.39.576.522.916l.861-.266.18.583-.862.265zm-7.937 2.447c.195.374.46.642.793.805.323.158.679.176 1.067.057.21-.065.379-.152.504-.262.124-.118.22-.25.29-.395.068-.154.119-.32.153-.499.022-.184.042-.38.057-.59l-2.864.884zm6.81-2.738a1.805 1.805 0 00-.79-.886 1.359 1.359 0 00-1.114-.121 1.318 1.318 0 00-.533.297c-.137.13-.241.282-.312.455-.071.172-.115.359-.133.56a4.014 4.014 0 00-.042.597l2.925-.902z"
        ></path>
        <circle
          cx="41.439"
          cy="32.051"
          r="2.366"
          fill={color}
          transform="rotate(-107.136 41.439 32.051)"
        ></circle>
        <path
          stroke={color}
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth="2.5"
          d="M105.781 37.923l1.791-7.6 7.021 3.417M17.858 73.106l-2.155 7.505-6.848-3.75"
        ></path>
        <path
          stroke={color}
          strokeLinecap="round"
          strokeWidth="2.5"
          d="M15.33 79.52C2.026 53.888 12.018 22.325 37.648 9.021c20.635-10.712 45.116-6.323 60.817 9.17M108.196 31.498c12.99 25.791 2.613 57.23-23.178 70.22-20.764 10.459-45.19 5.771-60.7-9.913"
        ></path>
        <path
          stroke={color}
          strokeWidth="2.5"
          d="M95.069 59.483L93.493 50.6a5.249 5.249 0 00-6.085-4.252l-54.515 9.67a5.249 5.249 0 00-4.252 6.085l4.797 27.04a5.249 5.249 0 006.085 4.252l54.515-9.67a5.25 5.25 0 004.251-6.085l-1.556-8.775"
        ></path>
        <rect
          width="17.447"
          height="8.404"
          x="82.317"
          y="61.983"
          fill="#fff"
          stroke={color}
          strokeWidth="2.5"
          rx="2.646"
          transform="rotate(-9.756 82.317 61.983)"
        ></rect>
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
          d="M35.135 60.818l52.683-9.199M40.572 87.484l52.548-9.459"
        ></path>
        <circle cx="87.82" cy="65.277" r="1.876" fill={color}></circle>
      </g>
      <defs>
        <clipPath id="clip0_3215_58553">
          <path
            fill="#fff"
            d="M0 0H121V109H0z"
            transform="translate(.979 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default TransactionsEmptyTableFeatureIcon
